(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "../../../";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea794"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea794"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("j6KIG", function(module, exports) {

$parcel$export(module.exports, "fetchPath", function () { return $de92d16f76d40821$export$5e86c84f80da1e08; });
$parcel$export(module.exports, "default", function () { return $de92d16f76d40821$export$2e2bcd8739ae039; });

var $6mFiP = parcelRequire("6mFiP");

var $5KOSn = parcelRequire("5KOSn");

var $hzIth = parcelRequire("hzIth");
const $de92d16f76d40821$var$showLoader = ()=>{
    document.documentElement.classList.add('is-loading');
    (0, $hzIth.toast)({
        message: 'Loading',
        type: 'loader'
    });
};
const $de92d16f76d40821$var$clearLoaderTimeout = (timeout, hasTimeout = true)=>{
    clearTimeout(timeout);
    if (hasTimeout) // NOTE: Add a deliberate delay to comprehend the spinner
    setTimeout((0, $hzIth.removeLoaderToast), 200);
    else (0, $hzIth.removeLoaderToast)();
};
const $de92d16f76d40821$var$getContextObject = (path)=>{
    const str = path && path.split('/')[3];
    const obj = {};
    if (str) {
        const params = str.split(':').filter((i)=>i).join('&').split('&');
        for(let i = 0; i < params.length; i = i + 2)obj[params[i]] = params[i + 1];
    }
    return obj;
};
let $de92d16f76d40821$var$controller;
let $de92d16f76d40821$var$loaderTimeout;
const $de92d16f76d40821$export$5e86c84f80da1e08 = async (state, isPushState)=>{
    const oldContext = $de92d16f76d40821$var$getContextObject(state.from);
    const newContext = $de92d16f76d40821$var$getContextObject(state.path);
    const csrfToken = document.head.querySelector('[name=csrf-token][content]').content;
    const setupLoader = ()=>$de92d16f76d40821$var$loaderTimeout = setTimeout($de92d16f76d40821$var$showLoader, (0, $5KOSn.PAGE_LOADER_DELAY_MS));
    try {
        setupLoader();
        if ($de92d16f76d40821$var$controller) $de92d16f76d40821$var$controller.abort();
        $de92d16f76d40821$var$controller = new AbortController();
        const response = await fetch(state.path, {
            method: 'get',
            headers: {
                Accept: 'roast/mixed',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-Token': csrfToken
            },
            signal: $de92d16f76d40821$var$controller.signal
        });
        const root = await (0, $6mFiP.handleResponse)(response, newContext, oldContext);
        if (state.path.includes('#')) window.location = state.path;
        $de92d16f76d40821$var$clearLoaderTimeout($de92d16f76d40821$var$loaderTimeout);
        if (root) {
            const newState = {
                path: state.path
            };
            if (isPushState && !response.headers.get('x-intra-redirect')) history.pushState(newState, '', state.path);
        }
    } catch (err) {
        if (err.name == 'AbortError') $de92d16f76d40821$var$clearLoaderTimeout($de92d16f76d40821$var$loaderTimeout, false);
        else console.error(err);
    }
};
const $de92d16f76d40821$var$stateFetch = async ()=>{
    const path = window.location.pathname + window.location.search;
    history.replaceState({
        path: path,
        title: document.title
    }, '', path);
    window.addEventListener('popstate', (popStateEvent)=>{
        setTimeout(()=>{
            $de92d16f76d40821$export$5e86c84f80da1e08(popStateEvent.state, false);
        }, 0);
        return true;
    });
};
var $de92d16f76d40821$export$2e2bcd8739ae039 = $de92d16f76d40821$var$stateFetch;

});
parcelRegister("6mFiP", function(module, exports) {

$parcel$export(module.exports, "handleResponse", function () { return $4a24d605994dbda4$export$c113a67a6762ad2e; });

var $f8RxH = parcelRequire("f8RxH");

var $j6KIG = parcelRequire("j6KIG");

var $hzIth = parcelRequire("hzIth");

var $gtJEK = parcelRequire("gtJEK");

var $1SS2L = parcelRequire("1SS2L");

var $hbEsA = parcelRequire("hbEsA");

var $2Aszf = parcelRequire("2Aszf");

var $8ZxWK = parcelRequire("8ZxWK");

var $l9d4Z = parcelRequire("l9d4Z");

var $6gwkO = parcelRequire("6gwkO");
const $4a24d605994dbda4$var$parseJson = (j = '{}')=>{
    try {
        if (typeof j !== 'object') return JSON.parse(j || '{}');
        else return j;
    } catch (error) {
        return {};
    }
};
const $4a24d605994dbda4$var$setFocus = (nextRoot)=>{
    let elementToFocus = nextRoot.querySelector('[autofocus], [data-kui-navigation-custom-focus]');
    const isInsideInertContainer = elementToFocus?.closest('[inert]');
    if (elementToFocus?.hasAttribute('data-kui-navigation-custom-focus')) elementToFocus.setAttribute('tabindex', '-1');
    if (!elementToFocus || isInsideInertContainer) {
        const h1s = nextRoot.querySelectorAll('main h1, [role="dialog"] h1');
        h1s.forEach((item)=>{
            item?.setAttribute('tabindex', '-1');
            elementToFocus = item;
        });
    }
    elementToFocus?.focus();
};
const $4a24d605994dbda4$var$persistTreeViewState = (prevRoot, nextRoot)=>{
    const prevTrees = prevRoot.querySelectorAll('[data-kui-tree-view-state-persisted][id]');
    const nextTrees = nextRoot.querySelectorAll('[data-kui-tree-view-state-persisted][id]');
    if (!prevTrees || !nextTrees) return;
    prevTrees.forEach((prevTree)=>{
        const id = prevTree.id;
        if (!id) return;
        const nextTree = nextRoot.querySelector(`[data-kui-tree-view-state-persisted][id="${id}"]`);
        if (!nextTree) return;
        // Collect open paths from prevTree
        const openTitles = [];
        prevTree.querySelectorAll('details[open] > summary').forEach((summary)=>{
            openTitles.push(summary.getAttribute('title'));
        });
        // Restore open state in nextTree
        nextTree.querySelectorAll('details > summary').forEach((summary)=>{
            if (openTitles.includes(summary.getAttribute('title'))) summary.parentElement.setAttribute('open', '');
            else summary.parentElement.removeAttribute('open');
        });
    });
};
const $4a24d605994dbda4$var$persistShowHides = (newInput, oldInput)=>{
    const newRoot = newInput.closest('[data-toggle-display="root"]');
    const newTargets = newRoot.querySelectorAll('[data-toggle-display="target"]');
    const oldRoot = oldInput.closest('[data-toggle-display="root"]');
    const oldTargets = oldRoot.querySelectorAll('[data-toggle-display="target"]');
    [
        ...newTargets
    ].forEach((target, i)=>{
        target.hidden = oldTargets[i].hidden;
    });
};
const $4a24d605994dbda4$var$persistChecked = (oldInput, newInput)=>{
    const oldChecked = oldInput.checked;
    newInput.checked = oldChecked;
};
const $4a24d605994dbda4$var$persistValue = (oldInput, newInput)=>{
    const oldValue = oldInput.value;
    newInput.value = oldValue;
};
const $4a24d605994dbda4$var$persistInputs = (nextRoot)=>{
    [
        ...(0, $hbEsA.findAll)('[kui-input-persist]', nextRoot)
    ].forEach((newInput)=>{
        const isRadioCheckbox = [
            'radio',
            'checkbox'
        ].includes(newInput.type);
        const isConditionalField = newInput.hasAttribute('data-conditional-field');
        const oldInput = isRadioCheckbox ? (0, $2Aszf.find)(`[name='${newInput.getAttribute('name')}'][value='${newInput.getAttribute('value')}']`) : isConditionalField ? (0, $2Aszf.find)(`[name='${newInput.getAttribute('name')}']`) : (0, $2Aszf.find)((0, $f8RxH.getElementSelector)(newInput, {
            root: nextRoot
        }));
        if (oldInput) {
            const updateFunction = isRadioCheckbox ? $4a24d605994dbda4$var$persistChecked : $4a24d605994dbda4$var$persistValue;
            updateFunction(oldInput, newInput);
            if (isRadioCheckbox && newInput.getAttribute('kui-on-change') && newInput.getAttribute('kui-on-change').startsWith('toggleDisplay.')) $4a24d605994dbda4$var$persistShowHides(newInput, oldInput);
        }
    });
};
const $4a24d605994dbda4$var$replaceDom = (prevRoot, nextRoot, isFromHome, isToHome, isChangeSub, isChangeContext, isModalContext)=>{
    if (isChangeSub && !isModalContext) nextRoot.classList.add('has-page-transition');
    $4a24d605994dbda4$var$persistInputs(nextRoot);
    $4a24d605994dbda4$var$persistTreeViewState(prevRoot, nextRoot);
    const oldPageTitleEl = prevRoot.querySelector('[data-page-title]');
    const oldPageTitle = oldPageTitleEl.getAttribute('data-page-title');
    prevRoot.replaceWith(nextRoot);
    const pageTitleEl = nextRoot.querySelector('[data-page-title]');
    if (pageTitleEl) document.title = pageTitleEl.getAttribute('data-page-title');
    if (// If a modal URL, we don't want to set focus on the H1
    !isModalContext && (document.title !== oldPageTitle || isChangeContext)) $4a24d605994dbda4$var$setFocus(nextRoot);
    (0, $gtJEK.handleOnLoads)();
    return nextRoot;
};
const $4a24d605994dbda4$var$navigate = (res, oldContext, newContext)=>{
    const parser = new DOMParser();
    const dom = parser.parseFromString(res.html, 'text/html');
    // Default to roast root, use Kinde root for custom UI
    // as roast wouldn't make sense in that context
    // fall back to body so custom ui doesn't break if omitted
    let ROOT_SELECTOR = '[data-roast-root]';
    let prevRoot = document.querySelector(ROOT_SELECTOR);
    if (!prevRoot) {
        ROOT_SELECTOR = '[data-kinde-root]';
        prevRoot = document.querySelector(ROOT_SELECTOR);
    }
    if (!prevRoot) {
        ROOT_SELECTOR = 'body';
        prevRoot = document.body;
    }
    const nextRoot = (0, $2Aszf.find)(ROOT_SELECTOR, dom);
    const metaCsrf = dom.querySelector('meta[name="csrf-token"]');
    document.querySelector('meta[name="csrf-token"]').content = metaCsrf.content;
    const isFromHome = (0, $8ZxWK.isHome)(oldContext);
    const isToHome = (0, $8ZxWK.isHome)(newContext);
    const isModalContext = newContext && 'is_modal' in newContext;
    (async ()=>{
        await (0, $1SS2L.sleep)();
    })();
    if (nextRoot) $4a24d605994dbda4$var$replaceDom(prevRoot, nextRoot, isFromHome, isToHome, (0, $l9d4Z.isNewSub)(oldContext, newContext), (0, $6gwkO.isNewContext)(oldContext, newContext), isModalContext);
    return nextRoot;
};
const $4a24d605994dbda4$var$handleRedirect = (res)=>window.location = res.location;
const $4a24d605994dbda4$var$handleRefresh = ()=>(0, $j6KIG.fetchPath)(history.state, false);
const $4a24d605994dbda4$var$handleNoop = ()=>false;
const $4a24d605994dbda4$var$handlePolling = ()=>false;
const $4a24d605994dbda4$var$handleToast = (res)=>(0, $hzIth.toast)(res);
const $4a24d605994dbda4$var$handleAction = (action)=>{
    const actionMap = {
        show_toast: $4a24d605994dbda4$var$handleToast,
        noop: $4a24d605994dbda4$var$handleNoop,
        polling: $4a24d605994dbda4$var$handlePolling,
        redirect: $4a24d605994dbda4$var$handleRedirect,
        refresh_content: $4a24d605994dbda4$var$handleRefresh
    };
    return actionMap[action] ? actionMap[action] : actionMap.noop;
};
const $4a24d605994dbda4$var$handleMixed = async (response, oldContext, newContext)=>{
    try {
        const res = await response.json();
        const json = $4a24d605994dbda4$var$parseJson(res.json);
        const html = $4a24d605994dbda4$var$parseJson(res.html);
        if (json && (json.action || json.actions)) {
            const actions = json.actions || [
                json
            ];
            actions.forEach((item)=>$4a24d605994dbda4$var$handleAction(item.action)(item));
        }
        if (json && json.action === 'noop') return 'noop';
        if (res.html && !html.actions) return $4a24d605994dbda4$var$navigate(res, oldContext, newContext);
        if (json?.actions?.[0]?.action === 'polling') return {
            action: 'polling',
            ...json.actions[0]
        };
    } catch (err) {
        console.error(err);
    }
};
const $4a24d605994dbda4$var$handleUnknownResponseType = (response)=>{
    console.error(`Unknown response content-type. Received: ${response.headers.get('content-type')}. Expected: roast/mixed`);
};
const $4a24d605994dbda4$var$handleFileToLarge = ()=>{
    throw 'Your uploaded file is too large, check the accepted size';
};
const $4a24d605994dbda4$var$getHandleCode = (code)=>{
    const map = {
        413: $4a24d605994dbda4$var$handleFileToLarge,
        default: $4a24d605994dbda4$var$handleUnknownResponseType
    };
    return map[code] ? map[code] : map.default;
};
const $4a24d605994dbda4$var$handleTextHTML = (response)=>{
    const handleCode = $4a24d605994dbda4$var$getHandleCode(response.status);
    handleCode(response);
};
const $4a24d605994dbda4$var$handleContentType = (contentType)=>{
    const map = {
        'text/html': $4a24d605994dbda4$var$handleTextHTML,
        'roast/mixed': $4a24d605994dbda4$var$handleMixed,
        default: $4a24d605994dbda4$var$handleUnknownResponseType
    };
    return map[contentType] ? map[contentType] : map.default;
};
const $4a24d605994dbda4$export$c113a67a6762ad2e = async (response, newContext, oldContext)=>{
    const internalRedirectTo = response.headers.get('x-intra-redirect');
    const contentType = response.headers.get('content-type');
    if (internalRedirectTo && !history.state.path.endsWith(internalRedirectTo)) // Make back button skip pages it was redirected from (e.g. modal)
    history.pushState({
        path: internalRedirectTo
    }, '', internalRedirectTo);
    const func = $4a24d605994dbda4$var$handleContentType(contentType);
    return await func(response, oldContext, newContext);
};

});
parcelRegister("f8RxH", function(module, exports) {

$parcel$export(module.exports, "getElementSelector", function () { return $b06122cf8f9cca11$export$b609704f371f3e39; });
const $b06122cf8f9cca11$var$getAncestorElements = (element, parameters)=>{
    const ancestors = [];
    while(element){
        if (parameters?.root && element == parameters?.root) break;
        const tagName = element.nodeName.toLowerCase();
        const id = element.id ? `#${element.id}` : '';
        let className = '';
        if (element.className && typeof element.className === 'string') // escape class names
        className = `.${element.className.trim().replace(/\s+/g, '.').replace(/[:*+?^${}()|[\]\\]/gi, '\\$&')}`;
        ancestors.unshift({
            element: element,
            selector: tagName + id + className
        });
        element = element.parentNode !== document ? element.parentNode : false;
    }
    return ancestors;
};
const $b06122cf8f9cca11$var$getNthIndex = (element, sameType = true)=>{
    let c = element;
    let nth = 1;
    while(c.previousElementSibling !== null){
        if (!sameType || c.previousElementSibling.nodeName === element.nodeName) nth++;
        c = c.previousElementSibling;
    }
    return nth;
};
const $b06122cf8f9cca11$var$isNthSelectorNeeded = (selector, path)=>{
    const querySelector = path === '' ? selector : `${path} > ${selector}`;
    return document.querySelectorAll(querySelector).length > 1;
};
const $b06122cf8f9cca11$var$buildSelectorString = (parents)=>{
    const selectorArr = [];
    parents.forEach((parent)=>{
        if ($b06122cf8f9cca11$var$isNthSelectorNeeded(parent.selector, selectorArr.join(' > '))) parent.selector += `:nth-of-type(${$b06122cf8f9cca11$var$getNthIndex(parent.element)})`;
        selectorArr.push(parent.selector);
    });
    return selectorArr.join(' > ');
};
const $b06122cf8f9cca11$export$b609704f371f3e39 = (element, parameters)=>{
    if (!(element instanceof HTMLElement)) throw new Error('element must be of type `HTMLElement`.');
    return $b06122cf8f9cca11$var$buildSelectorString($b06122cf8f9cca11$var$getAncestorElements(element, parameters));
};

});

parcelRegister("hzIth", function(module, exports) {

$parcel$export(module.exports, "removeLoaderToast", function () { return $ccb8339aa2d3a678$export$72601a8e7a675d38; });
$parcel$export(module.exports, "toast", function () { return $ccb8339aa2d3a678$export$b410431fab84fa58; });
/* Draws heavy influence from https://web.dev/building-a-toast-component/ */ const $ccb8339aa2d3a678$var$Toaster = document.querySelector('[data-kui-toaster]');
const $ccb8339aa2d3a678$var$cloneToastTemplate = (msg, type)=>{
    const template = document.querySelector('[data-kui-toast-template]');
    const clone = template.content.cloneNode(true);
    const containerEl = clone.querySelector(':first-child');
    const msgEl = clone.querySelector('[data-kui-toast-msg]');
    containerEl.classList.add(`kui-toast--${type}`);
    containerEl.setAttribute(`data-kui-toast-${type}`, 'true');
    msgEl.textContent = msg;
    return clone;
};
const $ccb8339aa2d3a678$var$addToQueue = (toast)=>{
    const first = $ccb8339aa2d3a678$var$Toaster.offsetHeight;
    $ccb8339aa2d3a678$var$Toaster.appendChild(toast);
    const last = $ccb8339aa2d3a678$var$Toaster.offsetHeight;
    const invert = last - first;
    $ccb8339aa2d3a678$var$Toaster.animate([
        {
            transform: `translateY(${invert}px)`
        },
        {
            transform: 'translateY(0)'
        }
    ], {
        duration: 150,
        easing: 'ease-out'
    });
};
const $ccb8339aa2d3a678$var$addToast = (toast)=>{
    const { matches: motionOK } = window.matchMedia('(prefers-reduced-motion: no-preference)');
    $ccb8339aa2d3a678$var$Toaster.children.length && motionOK ? $ccb8339aa2d3a678$var$addToQueue(toast) : $ccb8339aa2d3a678$var$Toaster.appendChild(toast);
};
const $ccb8339aa2d3a678$export$72601a8e7a675d38 = ()=>{
    if (!$ccb8339aa2d3a678$var$Toaster) return;
    const toastEl = $ccb8339aa2d3a678$var$Toaster.querySelector('[data-kui-toast-loader]:first-child');
    if (toastEl) $ccb8339aa2d3a678$var$Toaster.removeChild(toastEl);
    document.documentElement.classList.remove('is-loading');
};
const $ccb8339aa2d3a678$var$showToast = (res)=>{
    const { message: message, type: type = 'success' } = res;
    const clone = $ccb8339aa2d3a678$var$cloneToastTemplate(message, type);
    const isLoader = type === 'loader';
    if (isLoader) $ccb8339aa2d3a678$var$Toaster.appendChild(clone);
    else {
        $ccb8339aa2d3a678$var$addToast(clone);
        const toastEl = $ccb8339aa2d3a678$var$Toaster.querySelector('[data-kui-toast]:last-child');
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve)=>{
            await Promise.allSettled(toastEl.getAnimations().map((animation)=>animation.finished));
            $ccb8339aa2d3a678$var$Toaster.removeChild(toastEl);
            resolve();
        });
    }
};
const $ccb8339aa2d3a678$export$b410431fab84fa58 = (res = {})=>{
    if (!$ccb8339aa2d3a678$var$Toaster) return;
    $ccb8339aa2d3a678$var$showToast(res);
};

});

parcelRegister("gtJEK", function(module, exports) {

$parcel$export(module.exports, "handleOnLoads", function () { return $bff2c527231b1015$export$c015d9a87e159176; });
$parcel$export(module.exports, "bind", function () { return $bff2c527231b1015$export$2385a24977818dd0; });

var $fz6uS = parcelRequire("fz6uS");

var $ctacp = parcelRequire("ctacp");

var $j6KIG = parcelRequire("j6KIG");

var $7fqiw = parcelRequire("7fqiw");

var $csemq = parcelRequire("csemq");
const $bff2c527231b1015$var$handledNativeEvents = [
    'click',
    'change',
    'mouseup',
    'input',
    'keyup',
    'keydown',
    'submit',
    'focusin',
    'blur'
];
const $bff2c527231b1015$var$fire = (el, handler, e)=>{
    const attribute = el.getAttribute(handler);
    const eventHandlers = attribute.trim().split(' ');
    eventHandlers.forEach((method)=>{
        const parts = method.split('.');
        (0, $fz6uS.eventMap)[parts[0]][parts[1]](el, e);
    });
};
const $bff2c527231b1015$var$fireClosestHandler = (e)=>{
    const handler = `kui-on-${e.type}`;
    const el = e.target.closest(`[${handler}]`);
    if (el) $bff2c527231b1015$var$fire(el, handler, e);
};
const $bff2c527231b1015$export$c015d9a87e159176 = ()=>{
    const handler = 'kui-on-load';
    const loadEls = document.querySelectorAll(`[${handler}]`);
    (0, $ctacp.each)(loadEls, (el)=>$bff2c527231b1015$var$fire(el, handler));
};
const $bff2c527231b1015$var$handleNativeEvents = ()=>{
    $bff2c527231b1015$var$handledNativeEvents.forEach((type)=>{
        document.body.addEventListener(type, $bff2c527231b1015$var$fireClosestHandler, true);
    });
};
const $bff2c527231b1015$var$navigate = (e)=>{
    const el = e.target.closest('a');
    if (el && el.hostname === window.location.hostname && !el.hasAttribute('download') && !el.hasAttribute('data-force-page-reload-via-link') && !el.hasAttribute('data-in-page-link')) {
        e.preventDefault();
        if ((0, $csemq.hasUnsavedChanges)()) {
            if (!confirm(`Are you sure you want to leave this page? Your changes won't be saved.`)) //  User asked to stay, do not redirect
            return;
            else (0, $csemq.resetUnsavedChanges)();
        }
        const path = el.pathname + el.search;
        (0, $j6KIG.fetchPath)({
            path: path,
            from: window.location.pathname
        }, true);
    }
};
const $bff2c527231b1015$var$handleInternalLinks = ()=>{
    document.body.addEventListener('click', $bff2c527231b1015$var$navigate);
};
const $bff2c527231b1015$var$handleFormSubmit = ()=>{
    document.body.addEventListener('submit', (0, $7fqiw.formSubmit));
};
const $bff2c527231b1015$export$2385a24977818dd0 = ()=>{
    $bff2c527231b1015$var$handleInternalLinks();
    $bff2c527231b1015$var$handleFormSubmit();
    $bff2c527231b1015$var$handleNativeEvents();
    $bff2c527231b1015$export$c015d9a87e159176();
};

});
parcelRegister("fz6uS", function(module, exports) {

$parcel$export(module.exports, "eventMap", function () { return $b54f2a0c1700ce31$export$ad0af8749a496627; });
$parcel$export(module.exports, "register", function () { return $b54f2a0c1700ce31$export$6503ec6e8aabbaf; });
const $b54f2a0c1700ce31$export$ad0af8749a496627 = {};
function $b54f2a0c1700ce31$export$6503ec6e8aabbaf(controller, methods) {
    $b54f2a0c1700ce31$export$ad0af8749a496627[controller] = methods;
}

});

parcelRegister("ctacp", function(module, exports) {

$parcel$export(module.exports, "each", function () { return $91401ad0b92b6fd0$export$79b2f7037acddd43; });
const $91401ad0b92b6fd0$export$79b2f7037acddd43 = (array, func, inc = 1)=>{
    for(let i = 0; i < array.length; i += inc)func(array[i], i);
};

});

parcelRegister("7fqiw", function(module, exports) {

$parcel$export(module.exports, "formSubmit", function () { return $546e5551d0d8feb6$export$e382ca0e4dd19c27; });

var $6mFiP = parcelRequire("6mFiP");

var $csemq = parcelRequire("csemq");

var $iUGoV = parcelRequire("iUGoV");

var $4hVTo = parcelRequire("4hVTo");
let $546e5551d0d8feb6$var$isFormSubmitting = false;
const $546e5551d0d8feb6$export$e382ca0e4dd19c27 = async (e)=>{
    const form = e.target;
    // Ignore forms that purely close dialogs via `method="dialog"`
    if (form.method === 'dialog') return;
    const isFileUpload = form.getAttribute('data-is-file-upload');
    const isEndUserForm = form.getAttribute('data-kinde-form'); // NOTE: This will be used everywhere eventually
    if (form) e.preventDefault();
    (0, $csemq.resetUnsavedChanges)();
    /* Prevent multiple submissions */ if ($546e5551d0d8feb6$var$isFormSubmitting) return false;
    $546e5551d0d8feb6$var$isFormSubmitting = true;
    // Factor in forms submitted by remote buttons
    const submitButton = isFileUpload ? form.querySelector('[data-kui-file-upload-trigger]') : e.submitter || form.querySelector('button[type="submit"]');
    const liveRegion = submitButton.nextElementSibling;
    const submitButtonText = (0, $4hVTo.getLoadingButtonText)(submitButton);
    if (isEndUserForm) (0, $4hVTo.loadingButton)(submitButton);
    else {
        form.classList.add('is-loading');
        submitButton.classList.add('is-loading');
        if (liveRegion) liveRegion.textContent = isFileUpload ? 'File is uploading' : 'Form is submitting';
    }
    const formData = new FormData(form);
    const searchParams = new URLSearchParams();
    for (const [key, value] of searchParams.entries())formData.append(key, value);
    if (submitButton.getAttribute('name')) formData.append(submitButton.getAttribute('name'), submitButton.getAttribute('value'));
    const path = form.action;
    const csrfToken = document.head.querySelector('[name=csrf-token][content]').content;
    let responseType;
    try {
        const response = await fetch(path, {
            method: form.method,
            body: formData,
            redirect: 'error',
            headers: {
                Accept: 'roast/mixed',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-Token': csrfToken,
                'X-Client-Time': Date.now()
            }
        });
        responseType = await (0, $6mFiP.handleResponse)(response);
    } catch (error) {
        if (isEndUserForm) (0, $4hVTo.restoreLoadingButton)(submitButton, submitButtonText);
        else {
            form.classList.remove('is-loading');
            submitButton.classList.remove('is-loading');
            (0, $iUGoV.showFormFieldError)(form, error);
            liveRegion.textContent = '';
        }
    } finally{
        // Means forms can't be resubmitted whilst redirect takes place
        if (responseType !== 'redirect') $546e5551d0d8feb6$var$isFormSubmitting = false;
    }
};

});
parcelRegister("csemq", function(module, exports) {

$parcel$export(module.exports, "hasUnsavedChanges", function () { return $91133d46d786c89d$export$cb4fe9993410f0a9; });
$parcel$export(module.exports, "resetUnsavedChanges", function () { return $91133d46d786c89d$export$3299f181c601479d; });
$parcel$export(module.exports, "unsavedChanges", function () { return $91133d46d786c89d$export$ba693124bd9dae7; });

var $fz6uS = parcelRequire("fz6uS");
let $91133d46d786c89d$var$isDirty = false;
const $91133d46d786c89d$export$cb4fe9993410f0a9 = ()=>$91133d46d786c89d$var$isDirty;
const $91133d46d786c89d$var$handleUnload = (e)=>{
    e.preventDefault();
    return e.returnValue = '';
};
const $91133d46d786c89d$export$3299f181c601479d = ()=>{
    $91133d46d786c89d$var$isDirty = false;
    window.removeEventListener('beforeunload', $91133d46d786c89d$var$handleUnload);
};
function $91133d46d786c89d$var$handleChange() {
    $91133d46d786c89d$var$isDirty = true;
    window.addEventListener('beforeunload', $91133d46d786c89d$var$handleUnload);
}
const $91133d46d786c89d$var$setFormListeners = (form)=>{
    const fields = form.querySelectorAll('input, select, textarea');
    [
        ...fields
    ].forEach((field)=>{
        // eslint-disable-next-line no-constant-condition
        const eventType = field.nodeName = 'change';
        field.addEventListener(eventType, $91133d46d786c89d$var$handleChange);
    });
};
const $91133d46d786c89d$var$init = (form)=>{
    $91133d46d786c89d$var$setFormListeners(form);
};
const $91133d46d786c89d$export$ba693124bd9dae7 = ()=>{
    (0, $fz6uS.register)('unsavedChanges', {
        init: $91133d46d786c89d$var$init
    });
};

});

parcelRegister("iUGoV", function(module, exports) {

$parcel$export(module.exports, "showFormFieldError", function () { return $dc4e58f08b054199$export$2d721e062bd3690; });
const $dc4e58f08b054199$var$KUI_FORM_VALIDATION_MSG_CLIENT = 'kui-form-validation-msg-client';
const $dc4e58f08b054199$var$KUI_FORM_VALIDATION_MSG_SERVER = 'kui-form-validation-msg-server';
const $dc4e58f08b054199$var$KUI_FORM_VALIDATION_INPUT = 'kui-form-validation-input';
const $dc4e58f08b054199$export$2d721e062bd3690 = (form, error)=>{
    if (!form && !error) return;
    const input = form.querySelector(`[${$dc4e58f08b054199$var$KUI_FORM_VALIDATION_INPUT}]`);
    const errorMsgClient = form.querySelector(`[${$dc4e58f08b054199$var$KUI_FORM_VALIDATION_MSG_CLIENT}]`);
    const errorMsgServer = form.querySelector(`[${$dc4e58f08b054199$var$KUI_FORM_VALIDATION_MSG_SERVER}]`);
    // Remove server-side errors from DOM
    if (errorMsgServer) errorMsgServer.style.display = 'none';
    if (errorMsgClient) {
        errorMsgClient.id = $dc4e58f08b054199$var$KUI_FORM_VALIDATION_MSG_CLIENT;
        errorMsgClient.classList.add('kui-form-field-error-msg', 'kui-form-field-error-msg--variant-block', 'kui-util-type-body-2');
        errorMsgClient.textContent = error;
    }
    if (input) {
        input.setAttribute('aria-describedby', $dc4e58f08b054199$var$KUI_FORM_VALIDATION_MSG_CLIENT);
        input.setAttribute('aria-invalid', 'true');
    }
};

});

parcelRegister("4hVTo", function(module, exports) {

$parcel$export(module.exports, "loadingButton", function () { return $31f5a82c13f10444$export$e737248121a0521e; });
$parcel$export(module.exports, "getLoadingButtonText", function () { return $31f5a82c13f10444$export$91fa9d984f13195b; });
$parcel$export(module.exports, "restoreLoadingButton", function () { return $31f5a82c13f10444$export$2fb0d2e5caf27b0c; });

var $702R2 = parcelRequire("702R2");
const $31f5a82c13f10444$export$e737248121a0521e = (el)=>{
    if (!el) return;
    const spinnerTemplate = el.nextElementSibling;
    const spinnerContent = spinnerTemplate.content.cloneNode(true);
    el.classList.add('kinde-is-loading');
    el.textContent = '';
    el.appendChild(spinnerContent);
    el.setAttribute('aria-disabled', 'true');
    (0, $702R2.generateLiveRegion)('formSubmit');
};
const $31f5a82c13f10444$export$91fa9d984f13195b = (el)=>{
    const buttonTextEl = el.querySelector('[data-kinde-button-text]');
    if (!buttonTextEl) return;
    return buttonTextEl.textContent;
};
const $31f5a82c13f10444$export$2fb0d2e5caf27b0c = (el, originalText)=>{
    if (!el) return;
    const spinnerEl = el.querySelector('[data-kinde-form-submit-spinner]');
    if (spinnerEl) spinnerEl.remove();
    const buttonTextEl = document.createElement('span');
    buttonTextEl.className = 'kinde-button-text';
    buttonTextEl.setAttribute('data-kinde-button-text', 'true');
    buttonTextEl.textContent = originalText;
    el.classList.remove('kinde-is-loading');
    el.removeAttribute('aria-disabled');
    el.appendChild(buttonTextEl);
    (0, $702R2.clearLiveRegion)();
};

});
parcelRegister("702R2", function(module, exports) {

$parcel$export(module.exports, "clearLiveRegion", function () { return $518abf5454365452$export$6d886893bb3bfb69; });
$parcel$export(module.exports, "getLiveRegion", function () { return $518abf5454365452$export$1870415c73c2ac8e; });
$parcel$export(module.exports, "generateLiveRegion", function () { return $518abf5454365452$export$27a9c3442f02de69; });

var $1Fs9P = parcelRequire("1Fs9P");
const $518abf5454365452$var$LiveRegion = document.querySelector('[data-kinde-live-region]');
const $518abf5454365452$var$LiveRegionNames = {
    copyToClipboard: 'CopyToClipboard',
    copyToClipboardAlt: 'CopyToClipboardAlt',
    formLoading: 'FormLoading',
    formSubmit: 'FormSubmit'
};
const $518abf5454365452$export$6d886893bb3bfb69 = ()=>$518abf5454365452$var$LiveRegion.textContent = null;
const $518abf5454365452$export$1870415c73c2ac8e = (name)=>{
    if (!$518abf5454365452$var$LiveRegion) return;
    const dataAttrPrefix = 'kindeLiveRegion';
    const dataAttrName = `${dataAttrPrefix}${$518abf5454365452$var$LiveRegionNames[name]}`;
    if (!dataAttrName) {
        console.warn(`Kinde: No live region data attribute matching: \u{201C}${dataAttrName}\u{201D}`);
        return;
    }
    return $518abf5454365452$var$LiveRegion.dataset[dataAttrName];
};
const $518abf5454365452$export$27a9c3442f02de69 = (name, hasTimeout = false)=>{
    const liveRegion = $518abf5454365452$export$1870415c73c2ac8e(name);
    $518abf5454365452$var$LiveRegion.textContent = liveRegion;
    if (hasTimeout) setTimeout(()=>{
        $518abf5454365452$var$LiveRegion.textContent = null;
    }, (0, $1Fs9P.LIVE_REGION_TIMEOUT_MS));
};

});
parcelRegister("1Fs9P", function(module, exports) {

$parcel$export(module.exports, "ACTIVE_CLASS", function () { return $136f764b2acf5192$export$fb3d0eebfe85522a; });
$parcel$export(module.exports, "LIVE_REGION_TIMEOUT_MS", function () { return $136f764b2acf5192$export$eaa4066d935d3d0a; });
const $136f764b2acf5192$export$fb3d0eebfe85522a = 'is-kinde-active';
const $136f764b2acf5192$export$eaa4066d935d3d0a = 2000;

});





parcelRegister("1SS2L", function(module, exports) {

$parcel$export(module.exports, "sleep", function () { return $15f4c1838f37d4fc$export$e772c8ff12451969; });
const $15f4c1838f37d4fc$export$e772c8ff12451969 = (m = 150)=>new Promise((r)=>setTimeout(r, m));

});

parcelRegister("hbEsA", function(module, exports) {

$parcel$export(module.exports, "findAll", function () { return $c832d94974432df0$export$18200ea6c8035394; });
const $c832d94974432df0$export$18200ea6c8035394 = (selector, el = document)=>el.querySelectorAll(selector);

});

parcelRegister("2Aszf", function(module, exports) {

$parcel$export(module.exports, "find", function () { return $1e251a7aff534220$export$71aa6c912b956294; });
const $1e251a7aff534220$export$71aa6c912b956294 = (selector, el = document)=>el.querySelector(selector);

});

parcelRegister("8ZxWK", function(module, exports) {

$parcel$export(module.exports, "isHome", function () { return $68be5a55f6fc4fe7$export$947c0ccec8fe9e2a; });
const $68be5a55f6fc4fe7$export$947c0ccec8fe9e2a = (ctx)=>!ctx?.m || ctx?.m === 'home';

});

parcelRegister("l9d4Z", function(module, exports) {

$parcel$export(module.exports, "isNewSub", function () { return $f65495866b71a953$export$bcb4e29413feab9b; });
const $f65495866b71a953$export$bcb4e29413feab9b = (oldCtx, newCtx)=>oldCtx?.s !== newCtx?.s;

});

parcelRegister("6gwkO", function(module, exports) {

$parcel$export(module.exports, "isNewContext", function () { return $48fd51adba7f62d4$export$efd4e5a046bbe3a; });
const $48fd51adba7f62d4$export$efd4e5a046bbe3a = (oldCtx, newCtx)=>oldCtx !== newCtx;

});


parcelRegister("5KOSn", function(module, exports) {

$parcel$export(module.exports, "PAGE_LOADER_DELAY_MS", function () { return $4308b688fc81c95c$export$1b72fc6512ad82fc; });
const $4308b688fc81c95c$export$c67b16f016ec1b96 = 400;
const $4308b688fc81c95c$export$1b72fc6512ad82fc = 800;

});


parcelRegister("2FfCx", function(module, exports) {

$parcel$export(module.exports, "eventHandler", function () { return $1f0b8709834d8cd5$export$312115c8de5dbe92; });

var $fz6uS = parcelRequire("fz6uS");
const $1f0b8709834d8cd5$var$remove = (el)=>{
    const { eventHandlerToRemove: eventHandlerToRemove } = el.dataset;
    el.removeAttribute(eventHandlerToRemove);
};
const $1f0b8709834d8cd5$export$312115c8de5dbe92 = ()=>{
    (0, $fz6uS.register)('eventHandler', {
        remove: $1f0b8709834d8cd5$var$remove
    });
};

});

parcelRegister("kHyjp", function(module, exports) {

$parcel$export(module.exports, "formatCurrency", function () { return $f122707900906266$export$3dc27271f5d5c629; });

var $fz6uS = parcelRequire("fz6uS");
const $f122707900906266$var$init = (el)=>{
    const currencyCode = el.getAttribute('data-kinde-currency-code');
    // Extract the first number (integer or decimal) from the text content
    const match = el.textContent.match(/-?\d+(\.\d+)?/);
    const value = match ? Number(match[0]) : NaN;
    if (isNaN(value)) return;
    const formattedValue = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode,
        currencyDisplay: 'narrowSymbol',
        trailingZeroDisplay: 'stripIfInteger'
    }).format(value);
    el.textContent = formattedValue;
};
const $f122707900906266$export$3dc27271f5d5c629 = ()=>{
    (0, $fz6uS.register)('formatCurrency', {
        init: $f122707900906266$var$init
    });
};

});

parcelRegister("5IYSz", function(module, exports) {

module.exports = (parcelRequire("bw94A"))($parcel$resolve("f2ukl")).then(()=>parcelRequire('lXT01'));

});
parcelRegister("bw94A", function(module, exports) {
"use strict";

var $3AWh9 = parcelRequire("3AWh9");
module.exports = $3AWh9(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("3AWh9", function(module, exports) {
"use strict";
var $29e1f03a8422efb8$var$cachedBundles = {};
var $29e1f03a8422efb8$var$cachedPreloads = {};
var $29e1f03a8422efb8$var$cachedPrefetches = {};
function $29e1f03a8422efb8$var$getCache(type) {
    switch(type){
        case 'preload':
            return $29e1f03a8422efb8$var$cachedPreloads;
        case 'prefetch':
            return $29e1f03a8422efb8$var$cachedPrefetches;
        default:
            return $29e1f03a8422efb8$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $29e1f03a8422efb8$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $1ea8a99027f06a49$exports = {};
$parcel$extendImportMap({
    "f2ukl": "main.2d6cde7e.js"
});


var $j6KIG = parcelRequire("j6KIG");

var $gtJEK = parcelRequire("gtJEK");

var $2FfCx = parcelRequire("2FfCx");

var $kHyjp = parcelRequire("kHyjp");

var $fz6uS = parcelRequire("fz6uS");

var $702R2 = parcelRequire("702R2");

var $1Fs9P = parcelRequire("1Fs9P");
const $dd7f95fd4f074de8$var$copy = (button, value)=>{
    navigator.clipboard.writeText(value).then(()=>{
        const buttonInitialText = button.querySelector('[data-kinde-button-text]');
        let buttonText;
        if (buttonInitialText) {
            buttonText = buttonInitialText.textContent;
            buttonInitialText.textContent = (0, $702R2.getLiveRegion)('copyToClipboardAlt');
        }
        button.classList.add((0, $1Fs9P.ACTIVE_CLASS));
        button.disabled = true;
        (0, $702R2.generateLiveRegion)('copyToClipboard', true);
        setTimeout(()=>{
            if (buttonText) buttonInitialText.textContent = buttonText;
            button.classList.remove((0, $1Fs9P.ACTIVE_CLASS));
            button.disabled = false;
        }, (0, $1Fs9P.LIVE_REGION_TIMEOUT_MS));
    }).catch((err)=>{
        console.error('Kinde: Failed to copy to clipboard: ', err);
    });
};
const $dd7f95fd4f074de8$var$init = (el)=>{
    if (!el) return;
    const value = el.value;
    $dd7f95fd4f074de8$var$copy(el, value);
};
const $dd7f95fd4f074de8$export$2cdf1b96a9f86d16 = ()=>{
    (0, $fz6uS.register)('copyToClipboard', {
        init: $dd7f95fd4f074de8$var$init
    });
};


const $4c11cf6fa7fc19a6$var$verify = (selector, message, type = 'warn')=>{
    const el = document.querySelector(selector);
    if (!el) console[type](`[Kinde] ${message}`);
};
const $4c11cf6fa7fc19a6$export$38e50a4320b05777 = ()=>{
    $4c11cf6fa7fc19a6$var$verify('[data-kinde-root]', "\uD83D\uDEA8 No entry point found. Recommend using [data-kinde-root] to set an SPA entry point");
    $4c11cf6fa7fc19a6$var$verify('[data-kinde-layout-widget]', "\uD83D\uDEA8 No widget found. Make sure you are importing getKindeWidget from the @kinde/infrastructure package", 'error');
};



var $fz6uS = parcelRequire("fz6uS");
const $3463509dcd4abe11$var$init = (el)=>{
    const form = el.form;
    if (!form) return;
    const hook = 'data-kinde-is-invalid-control-focussed';
    if (!form.getAttribute(hook)) {
        const invalidControls = form.querySelectorAll('[aria-invalid="true"]');
        const firstInvalidControl = invalidControls[0];
        // Set a flag so it only runs once
        form.setAttribute(hook, 'true');
        firstInvalidControl.focus({
            focusVisible: true
        });
    }
};
const $3463509dcd4abe11$export$586190a6ccdbede0 = ()=>{
    (0, $fz6uS.register)('focusInvalidControl', {
        init: $3463509dcd4abe11$var$init
    });
};



var $fz6uS = parcelRequire("fz6uS");
const $5e439adf6d95aa15$var$init = ()=>window.print();
const $5e439adf6d95aa15$export$4a00e0d5599ae300 = ()=>{
    (0, $fz6uS.register)('printDialog', {
        init: $5e439adf6d95aa15$var$init
    });
};



var $fz6uS = parcelRequire("fz6uS");
const $8cd6f6814da0bba7$var$updateMaskText = (selectEl)=>{
    const maskEl = selectEl.nextElementSibling;
    if (!maskEl) return;
    const selectedOption = selectEl.options[selectEl.selectedIndex];
    const maskText = selectedOption.dataset.kindeControlSelectMaskText;
    maskEl.textContent = maskText;
};
const $8cd6f6814da0bba7$var$change = (el)=>{
    if (!el) return;
    $8cd6f6814da0bba7$var$updateMaskText(el);
};
const $8cd6f6814da0bba7$var$load = (el)=>{
    const selectEl = el.querySelector('select');
    if (!el && !selectEl) return;
    $8cd6f6814da0bba7$var$updateMaskText(selectEl);
};
const $8cd6f6814da0bba7$export$9f733b8d9ef60322 = ()=>{
    // NOTE: We can’t assign the `load` event to the `select` element as it’s
    // taken by `focusInvalidControl()`, so we have to assign it to the parent
    // element instead
    (0, $fz6uS.register)('showControlSelectMaskText', {
        change: $8cd6f6814da0bba7$var$change,
        load: $8cd6f6814da0bba7$var$load
    });
};



var $fz6uS = parcelRequire("fz6uS");
const $63b0cefd22836c20$var$init = (el)=>{
    const form = el.form;
    if (!form) return;
    const messages = form.querySelectorAll('[data-kinde-control-pattern-message]');
    if (messages.length) messages.forEach((input)=>{
        const message = input.dataset.kindeControlPatternMessage;
        if (input.validity.patternMismatch) input.setCustomValidity(message);
        else input.setCustomValidity('');
    });
};
const $63b0cefd22836c20$export$e85b571fc6a13d4d = ()=>{
    (0, $fz6uS.register)('showControlPatternMessage', {
        init: $63b0cefd22836c20$var$init
    });
};



var $fz6uS = parcelRequire("fz6uS");

var $1Fs9P = parcelRequire("1Fs9P");
const $43a8c913f881d0a8$var$init = (el)=>{
    const input = el.previousElementSibling;
    if (!el || !input) return;
    if (!el.dataset.kindeControlAddonButtonTextInitial) el.dataset.kindeControlAddonButtonTextInitial = el.getAttribute('aria-label');
    const initialLabel = el.dataset.kindeControlAddonButtonTextInitial;
    const actionedLabel = el.dataset.kindeControlAddonButtonTextActioned;
    el.classList.toggle((0, $1Fs9P.ACTIVE_CLASS));
    const isActive = el.classList.contains((0, $1Fs9P.ACTIVE_CLASS));
    const label = isActive ? actionedLabel : initialLabel;
    el.setAttribute('aria-label', label);
    el.setAttribute('title', label);
    input.type = isActive ? 'text' : 'password';
};
const $43a8c913f881d0a8$export$51255dd54ce0b33c = ()=>{
    (0, $fz6uS.register)('togglePasswordInputType', {
        init: $43a8c913f881d0a8$var$init
    });
};



var $fz6uS = parcelRequire("fz6uS");
const $5b7c0ba205baf3d5$var$init = (el)=>{
    if (!el) return;
    // Add key event handler for `SPACE` key
    el.addEventListener('keydown', (event)=>{
        if (event.key === ' ') {
            event.preventDefault(); // Prevent default scrolling behavior for SPACE
            el.click(); // Simulate a click event
        }
    });
};
const $5b7c0ba205baf3d5$export$e23450f1fdb47d78 = ()=>{
    (0, $fz6uS.register)('addLinkButtonKeyboardSupport', {
        init: $5b7c0ba205baf3d5$var$init
    });
};



var $fz6uS = parcelRequire("fz6uS");

const $b32591b18957b988$var$stripe = async ()=>{
    try {
        const Stripe = await (parcelRequire("5IYSz"));
        await Stripe.init();
    } catch (error) {
        console.error('Kinde: Error loading Stripe vendor dependency: ', error);
    }
};
const $b32591b18957b988$export$1e68305926741d49 = ()=>{
    (0, $fz6uS.register)('loadDependency', {
        stripe: $b32591b18957b988$var$stripe
    });
};


// Core
(0, $2FfCx.eventHandler)();
(0, $j6KIG.default)();
// Modules
(0, $5b7c0ba205baf3d5$export$e23450f1fdb47d78)();
(0, $dd7f95fd4f074de8$export$2cdf1b96a9f86d16)();
(0, $3463509dcd4abe11$export$586190a6ccdbede0)();
(0, $kHyjp.formatCurrency)();
(0, $b32591b18957b988$export$1e68305926741d49)();
(0, $5e439adf6d95aa15$export$4a00e0d5599ae300)();
(0, $63b0cefd22836c20$export$e85b571fc6a13d4d)();
(0, $8cd6f6814da0bba7$export$9f733b8d9ef60322)();
(0, $43a8c913f881d0a8$export$51255dd54ce0b33c)();
(0, $4c11cf6fa7fc19a6$export$38e50a4320b05777)();
// NOTE: `bind` has to come last to bind all other JS
(0, $gtJEK.bind)();

})();
//# sourceMappingURL=main.js.map
